var _g, _g2, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRightArrowWeb({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_b_4654_860)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 10C0 4.47715 4.47715 0 10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10Z",
    fill: "#EFEFEF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M0.172414 10C0.172414 4.57237 4.57237 0.172414 10 0.172414C15.4276 0.172414 19.8276 4.57237 19.8276 10C19.8276 15.4276 15.4276 19.8276 10 19.8276C4.57237 19.8276 0.172414 15.4276 0.172414 10Z",
    stroke: "white",
    strokeOpacity: 0.23,
    strokeWidth: 0.344828
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4654_860)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.3541 6.3324L9.20533 6.31583C9.01474 6.31583 8.85868 6.46913 8.85868 6.65972C8.85868 6.85031 9.01198 7.00637 9.20257 7.00637L12.5227 7.02018L6.52606 13.0168C6.39071 13.1521 6.39071 13.3703 6.52606 13.5057C6.6614 13.641 6.87961 13.641 7.01496 13.5057L13.0116 7.50907L13.0254 10.8292C13.0254 11.0197 13.1814 11.173 13.372 11.173C13.5626 11.173 13.7159 11.017 13.7159 10.8264L13.6993 6.67767C13.6979 6.48847 13.5433 6.33379 13.3541 6.3324Z",
    fill: "#292929"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_b_4654_860",
    x: -6.89655,
    y: -6.89655,
    width: 33.7931,
    height: 33.7931,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "BackgroundImageFix",
    stdDeviation: 3.44828
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "SourceAlpha",
    operator: "in",
    result: "effect1_backgroundBlur_4654_860"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_backgroundBlur_4654_860",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4654_860"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white",
    transform: "translate(2.5 9.48276) rotate(-45)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRightArrowWeb);
export default __webpack_public_path__ + "static/media/right-arrow-web.20aa8f878c1f6edd96c0b091f7c7af37.svg";
export { ForwardRef as ReactComponent };